import React from 'react';
import { Button } from 'react-bootstrap5';

export default function Start() {
  return (

    <Button
      variant="light"
      className="btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
      onClick={() => {
        // TODO: start TA
      }}
    >
      Report
    </Button>
  );
}
